import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from '@/components/common/Icon';
import Input from '@/components/common/Input';
import LoginBtn from '@/components/login/LoginBtn';
import LoginErrorBox from '@/components/login/LoginErrorBox';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import strings from '@/i18n/index';
import useAuthStore from '@/stores/authStore';
import useLogin from '@/stores/loginStore';
// import { useNavigate } from 'react-router-dom';
// import useAuth from '@/stores/authStore';
import useThemeStore from '@/stores/themeStore';
import { getResetPwdPathUrl } from '@/utils/getResetPwdPathUrl';
import * as SC from '@/views/Login/LoginForm.style';

const LoginForm = () => {
  const {
    id,
    changeId,
    password,
    changePassword,
    isShowPassword,
    toggleIsShowPassword,
    isLoading,
    loginStatus,
    login,
  } = useLogin();

  const { theme } = useThemeStore();
  const { saveUser } = useAuthStore();
  const navigate = useNavigate();
  const { showServerError } = useErrorHandler();

  const submitHandler: React.FormEventHandler<HTMLFormElement> = async (event) => {
    try {
      event.preventDefault();
      if (isLoading) {
        return;
      }

      const userInfo = await login();

      if (!userInfo) {
        return;
      }

      saveUser(userInfo);

      navigate('/chat', {
        replace: true,
      });
      return;

      // if (userInfo) {
      //   await connect(userInfo.userId);

      //   await sendbirdChat.updateCurrentUserInfo({
      //     profileUrl: `${import.meta.env.VITE_APP_API_URL}${userInfo?.userRegImg}` || '',
      //     nickname: userInfo.userName,
      //   });
      //   saveUser(userInfo);

      // }
    } catch (e) {
      showServerError('outOfChat');
    }
  };

  return (
    <div>
      <SC.Title>{strings.LOGIN}</SC.Title>
      <SC.Guide>{strings.LOGIN__GUIDE}</SC.Guide>
      <SC.FormWrapper aria-disabled={isLoading} onSubmit={submitHandler}>
        <Input
          placeholder={strings.LOGIN__EMAIL_OR_HP}
          type='text'
          value={id}
          withIcon
          fontSize='16px'
          height='48px'
          onChange={(e) => {
            changeId(e.target.value);
          }}
          wrapperStyle={{ marginBottom: '16px' }}
        >
          <Icon icon='IcLoginEmail' size='1.25rem' color={theme === 'dark' ? '#ffffff' : undefined} />
        </Input>
        <Input
          withIcon
          withView
          borderRadius='8px'
          fontSize='16px'
          height='48px'
          value={password}
          placeholder={strings.LOGIN__PASSWORD}
          type={isShowPassword ? 'text' : 'password'}
          handleShowPassword={toggleIsShowPassword}
          onChange={(e) => {
            changePassword(e.target.value);
          }}
          wrapperStyle={{ marginBottom: '24px' }}
        >
          <Icon icon='IcLoginPassword' size='1.25rem' color={theme === 'dark' ? '#ffffff' : undefined} />
        </Input>
        <LoginBtn
          disabled={Boolean(loginStatus.retryCountDown)}
          aria-disabled={Boolean(loginStatus.retryCountDown)}
          style={{ marginBottom: '12px' }}
          type='submit'
        />
      </SC.FormWrapper>
      <SC.FindPasswordWrapper>
        <SC.FindPasswordBtn
          onClick={() => {
            window.open(getResetPwdPathUrl(), '_blank');
          }}
        >
          <SC.FindPasswordText>{strings.FORGOT_PW}</SC.FindPasswordText>
        </SC.FindPasswordBtn>
      </SC.FindPasswordWrapper>
      {loginStatus.type !== 'NONE' && <LoginErrorBox />}
    </div>
  );
};

export default LoginForm;
